import React, { Fragment } from 'react'
import { Paper, Typography } from '@mui/material';
import { useDispatch, useSelector } from 'react-redux'
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import Avatar from '@mui/material/Avatar';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import ModalHistorialCambiosComponent from './ModalHistorialCambiosComponent';

function DomiciliosComponent(props) {

    const dispatch = useDispatch()

    const [calle, setCalle] = React.useState(props?.data?.calle?.toUpperCase())
    const [numerointerior, setNumeroInterior] = React.useState((props?.data?.numerointerior == '' || props?.data?.numerointerior == undefined || props?.data?.numerointerior == null) ? 'S/N' : props?.data?.numerointerior?.toUpperCase())
    const [numeroexterior, setNumeroExterior] = React.useState((props?.data?.numeroexterior == '' || props?.data?.numeroexterior == undefined || props?.data?.numerointerior == null) ? 'S/N' : props?.data?.numeroexterior?.toUpperCase())
    const [colonia, setColonia] = React.useState(props?.data?.colonia?.toUpperCase())
    const [localidad, setLocalidad] = React.useState(props?.data?.localidad?.toUpperCase())
    const [municipioalcaldia, setMunicipioAlcaldia] = React.useState(props?.data?.municipioalcaldia?.toUpperCase())
    const [estado, setEstado] = React.useState(props?.data?.estado?.toUpperCase())
    const [codigopostal, setCodigoPostal] = React.useState(props?.data?.codigopostal?.toUpperCase())


    const [openModalHistorial, setOpenModalHistorial] = React.useState(false);
    const [dataHistorial, setDataHistorial] = React.useState(props?.data?.domiciliofiscalclientehistorial);
    const handleModalHistorial = () => {
        setDataHistorial(props?.data?.domiciliofiscalclientehistorial)
        setOpenModalHistorial(true)
    }

    const theme = createTheme({
        palette: {
            primary: {
                main: "#EDB75A"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });

    return (
        <Fragment>
            <ThemeProvider theme={theme}>
                <Accordion>
                    <AccordionSummary expandIcon={<ExpandMoreIcon />} aria-controls="panel1a-content" id="panel1a-header" >
                        <Avatar sx={props?.data.isbaja ? { bgcolor: '#DC3545', width: '9%' } : { bgcolor: '#8ABE3E', width: '9%' }} variant="square"> {props?.data?.domicilioprincipal ?
                            <a href={`https://www.google.com/maps/search/${calle}, ${numeroexterior}, ${colonia}, ${localidad}, ${municipioalcaldia}, ${estado}`} target="_blank" rel="noopener noreferrer" style={{ color: 'white', textDecoration: 'none' }}>F</a> :
                            <a href={`https://www.google.com/maps/search/${calle}, ${numeroexterior}, ${colonia}, ${localidad}, ${municipioalcaldia}, ${estado}`} target="_blank" rel="noopener noreferrer" style={{ color: 'white', textDecoration: 'none' }}>S</a>}
                        </Avatar>
                        <Typography sx={{ width: '91%', flexShrink: 0, display: 'flex', alignItems: 'center', paddingLeft: '3%' }}>  {calle + ', ' + numerointerior + ', ' + numeroexterior + ', ' + colonia + ', ' + localidad + ', ' + municipioalcaldia + ', ' + estado + ', ' + codigopostal} </Typography>
                    </AccordionSummary>
                    <AccordionDetails>
                        <div className='row'>
                            <div className='row' style={{ margin: 0, padding: 0 }}>
                                {props?.data?.isbaja == false &&
                                    <div style={{ display: 'flex', justifyContent: 'end' }} >
                                        <Tooltip title="Ver historial de cambios">
                                            <IconButton size="large" sx={{ p: 1 }} onClick={() => { handleModalHistorial() }}>
                                                <HistoryRoundedIcon fontSize="inherit" sx={{ color: '#2B2B2B' }} />
                                            </IconButton>
                                        </Tooltip>
                                    </div>
                                }
                                <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Calle: <br /> </b> {calle} </label> </div>
                                <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Número Interior: <br /> </b> {numerointerior} </label> </div>
                                <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Número Exterior: <br /> </b> {numeroexterior} </label> </div>
                                <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Colonia: <br /> </b> {colonia} </label> </div>
                                <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Localidad: <br /> </b> {localidad} </label> </div>
                                <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Municipio: <br /> </b> {municipioalcaldia} </label> </div>
                                <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Estado: <br /> </b> {estado} </label> </div>
                                <div className="col-md-4 mt-3 ps-5 text-start"><label><b>Código postal: <br /> </b> {codigopostal} </label> </div>
                            </div>
                        </div>
                    </AccordionDetails>
                </Accordion>
            </ThemeProvider>
            {openModalHistorial && <ModalHistorialCambiosComponent setOpenModalHistorial={setOpenModalHistorial} dataHistorial={dataHistorial} apartado={"Domicilio"} />}
        </Fragment >
    )
}

export default DomiciliosComponent